import React from 'react';
import { SalesReports } from 'components/Payments';
import styles from './SalesSummary.module.scss';

interface SalesSummaryProps {
    description: string;
}

// Wrapper que ahora muestra una descripción y luego el bloque de reports
const SalesSummary: React.FC<SalesSummaryProps> = ({ description }) => {
    return (
        <div>
            <div className={styles.description}>{description}</div>
            <SalesReports
                className={styles.salesReport}
                showTitle={false}
            />
        </div>
    );
};

export default SalesSummary;
